import styled from 'styled-components'
import Input_ from '../atoms/input'
import TextArea_ from '../atoms/textarea'
import Button_ from '../atoms/button'

export const Form = styled.form`
  display: grid;
  grid-template-columns: 110px auto 110px;
  grid-column-gap: 1px;
  grid-row-gap: 1px;
  max-width: 750px;
  margin: 0 auto;
  line-height: 40px;
  text-transform: uppercase;
  color: #666e75;
  grid-row-gap: 20px;
`

export const Input = Input_.extend`
  grid-column: 2/3;
`

export const TextArea = TextArea_.extend`
  grid-column: 2/3;
  width: 100%;
`

export const ButtonContainer = styled.div`
  grid-column: 2/3;
  text-align: center;
`
export const Button = Button_.extend`
  width: 150px;
`

export const Label = styled.label`
  grid-column: 1/2;
`



// WEBPACK FOOTER //
// ./components/molecules/form.js